
const Index = () => import(/* webpackChunkName: "PriceTier" */ './index.vue');
const List = () => import(/* webpackChunkName: "PriceTier" */ './components/List.vue');

export default [
  {
    path: 'PriceTier',
    name: 'PriceTier',
    component: Index,
    title: 'PriceTier',
    redirect: { name: 'PriceTier-list' },
    children: [
      {
        path: 'list',
        name: 'PriceTier-list',
        component: List,
      },
    ],
  },
]
